//@ts-nocheck TODO; we have to remove this
import { MemberProps } from 'app/components/Core/convention'
import RentalCreateButton from 'app/components/Core/Rental/CreateButton'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useNavigate } from 'react-router'

const CreateRental: React.FC<MemberProps<IProject>> = ({ member, props = {} }) => {
  const navigate = useNavigate()

  const onSuccess = (rental: IRental) => {
    navigate(Routes.Checkout.member(String(rental.id)).machines)
  }

  return (
    <RentalCreateButton
      props={{ onSuccess, ...props }}
      member={{
        project_id: member.id,
        delivery_address1: member.address1,
        delivery_address2: member.address2,
        delivery_city: member.city,
        delivery_country: member.country,
        delivery_zip: member.zip,
        delivery_contact_id: member.last_delivery_contact_id
      }}
    />
  )
}

export default CreateRental
